/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { Link } from 'react-router';

import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { signInPath } from 'constants/urls';

import Icon from 'components/core/icon';
import FooterShared from 'components/shared/layout/footer';

import s from './styles.module.scss';

const logoUrl = '/logo.png';

const TermsConditions = ({ className = null, privacy }) => {
  const { t } = useTranslation();

  return (
    <div className={cx(s.helpPage, className)}>
      <div className={s.helpPageHeader}>
        <div className={s.sharedFormLogo} style={{ backgroundImage: `url(${logoUrl})` }} />
      </div>

      <Link to={signInPath} className={s.sharedFormTopLink}>
        <Icon className={s.sharedFormTopLinkIcon} icon={Icon.icons.arrowLeft} />
        <div className={s.sharedFormTopLinkText}>{t('back')}</div>
      </Link>

      <div className={s.helpPageContainer}>
        <div dangerouslySetInnerHTML={{ __html: privacy.content }} className={s.helpPageContent} />
      </div>

      <FooterShared className={s.sharedFormFooterRegistration}>
        <Link to={signInPath} className={s.sharedFormFooterLink}>
          {t('sign_in')}
        </Link>
      </FooterShared>
    </div>
  );
};

TermsConditions.propTypes = {
  className: PropTypes.string,
  privacy: PropTypes.shape({}).isRequired,
};

export default TermsConditions;
